import axios from "axios";
import { Toast } from "../../util/Toast";

import {
  GET_REPORTED_MOMENTS,
  DELETE_POST,
  DISMISS_REPORT,
} from "./types";

export const getReportedMoments = () => (dispatch) => {
  axios
    .get("/postReport/moments")
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: GET_REPORTED_MOMENTS, payload: res.data.report });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};


export const deletePost = (postId, postType) => (dispatch) =>
  axios
    .post("/postReport/action?action=delete", { postId, postType })
    .then((res) => {
      if (!res.data.status) {
        Toast("error", res.data.message);
        return false;
      }

      dispatch({ type: DELETE_POST, payload: { postId } });
      return true;
    })
    .catch((error) => {
      Toast("error", error.response?.data?.message || error.message);
      return false;
    });

export const dismissReport = (postId, postType) => (dispatch) =>
  axios
    .post("/postReport/dismiss", { postId, postType })
    .then((res) => {
      if (!res.data.status) {
        Toast("error", res.data.message);
        return false;
      }

      dispatch({ type: DISMISS_REPORT, payload: { postId } });
      return true;
    })
    .catch((error) => {
      Toast("error", error.response?.data?.message || error.message);
      return false;
    });
